import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { apiError } from "../lib/api";
import AuthShell from "./AuthShell";
import { Loader2, ShieldCheck, Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { staffLogin } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setRemember] = useState(true);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await staffLogin(email, password, remember);
      if (u.role !== "admin" && u.role !== "barber") {
        toast.error("This area is for staff only.");
        return;
      }
      toast.success("Welcome back!");
      navigate(u.role === "admin" ? "/admin/dashboard" : "/barber");
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  const field = "w-full bg-[#141414] border border-white/10 rounded-xl px-4 py-3 text-white placeholder-gray-500 focus:border-[#D4AF37] focus:ring-0 transition-colors duration-200";

  return (
    <AuthShell testid="admin-login-page" title="Staff Access" subtitle="Secure login for the shop owner and barbers.">
      <div className="flex items-center gap-2 text-[#D4AF37] mb-6 text-sm"><ShieldCheck className="w-4 h-4" /> Restricted area</div>
      <form onSubmit={submit} className="space-y-4">
        <input data-testid="admin-login-email" type="email" required placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} className={field} />
        <div className="relative">
          <input data-testid="admin-login-password" type={showPassword ? "text" : "password"} required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={field + " pr-12"} />
          <button type="button" data-testid="admin-login-password-toggle" onClick={() => setShowPassword((v) => !v)} aria-label={showPassword ? "Hide password" : "Show password"} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-[#D4AF37] transition-colors duration-200">
            {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
          </button>
        </div>
        <div className="flex items-center justify-between">
          <label className="flex items-center gap-2 text-sm text-gray-400 cursor-pointer"><input type="checkbox" data-testid="admin-remember" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="accent-[#D4AF37]" /> Remember me</label>
          <Link to="/forgot-password?admin=1" className="text-sm text-gray-400 hover:text-[#D4AF37]">Forgot password?</Link>
        </div>
        <button data-testid="admin-login-submit" disabled={loading} className="w-full py-3.5 rounded-full bg-[#D4AF37] text-black font-medium hover:bg-[#F3E5AB] transition-colors duration-300 disabled:opacity-60 flex items-center justify-center gap-2">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
        </button>
      </form>
    </AuthShell>
  );
}
